import { Layout } from '../../components/core';
import { InputMonitorWarning } from '../../content/assessment/components/InputMonitorWarning';
import { getRoute, useNavigate } from '../../routes';
import { FindCarePageWrapper } from './components/FindCarePageWrapper';
import { DemographicsForm } from './forms/DemographicsForm';
import { useFindCareRedirect } from './hooks/useFindCareRedirect';

export const FindCareDemographicsPage = (): JSX.Element => {
  const navigate = useNavigate();

  useFindCareRedirect();

  const onBack = (): void => {
    navigate(getRoute('findCareConfirmInfo', {}), { state: { redirect: false } });
  };

  return (
    <FindCarePageWrapper testID="find-care-user-demographics-page" onBackPress={onBack}>
      <Layout.VStack space={8}>
        <DemographicsForm />

        <InputMonitorWarning />
      </Layout.VStack>
    </FindCarePageWrapper>
  );
};
